<template>
  <el-card shadow="never" v-loading="loading">
    <el-alert v-if="error" :title="error" type="error"> </el-alert>
    <template slot="header">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }"
          >Dashboard</el-breadcrumb-item
        >
        <el-breadcrumb-item
          v-if="$root.state.facility"
          :to="{ name: 'Facility Customers' }"
          >{{
            String($root.state.facilityData.code).toUpperCase()
          }}
          Customers</el-breadcrumb-item
        >
        <el-breadcrumb-item v-else :to="{ name: 'Customers' }"
          >Customers</el-breadcrumb-item
        >
        <el-breadcrumb-item
          v-if="$root.state.facility"
          :to="{ name: 'Facility Customer', params: { id: customer._id, facility }  }"
          >{{ String($root.state.facilityData.code).toUpperCase() }}
          <i class="el-icon-connection" />
          {{ customer.company }}</el-breadcrumb-item
        >
        <el-breadcrumb-item v-else :to="{ name: 'Customer' }">{{
          customer.company
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <!-- <el-tabs v-model="activeTab" @tab-click="changeTab" tab-position="left"> -->
      <!-- <el-popover v-if="leaseTransfer"
        placement="top" trigger="hover" title="Lease Transfer Status" effect="light">
        <div>
          Active Stage: {{ leaseTransfer.transfer.activeStage }} of {{ leaseTransfer.transfer.stages }}
          <br />
          <span v-if="leaseTransfer.transfer.completed" class="text-success">Lease transfer completed.</span>
          <span v-else class="text-warning">Lease transfer is in progress.</span>
          <br />
        </div>
        <el-progress slot="reference"
          :stroke-width="12" :percentage="(leaseTransfer.transfer.activeStage / leaseTransfer.transfer.stages) * 100" :status="leaseTransfer.transfer.completed ? 'success' : 'warning'" style="margin-bottom: 10px;" show-text>
          <template #title>
            <span class="text-success">Lease Transfer</span>
          </template>
          <template #description>
            <span class="text-success">Lease transfer is in progress.</span>
          </template>
        </el-progress>
      </el-popover> -->
    <el-tabs v-model="activeTab" @tab-click="changeTab" tab-position="top">
      <el-tab-pane lazy label="Leasing" name="leasing">
        <el-tabs type="border-card" v-model="leaseTab" tab-position="top" @tab-click="refreshDataOnTabClick">
          <el-tab-pane lazy label="Active" name="lease">
            <CustomerLease
              ref="activeLeaseComponent"
              v-if="activeTab === 'leasing' && leaseTab === 'lease'"
              :id="id"
              :facility="facility"
              :customer="customer"
              :parent-loading="disableTransfer"
              @reload="getCustomerInvoices"
              :lease-transfer="leaseTransfer"
              :can-complete-moveout="canCompleteMoveout"
            />
          </el-tab-pane>
          <el-tab-pane lazy label="Future" name="future" v-if="hasFutureLease">
            <CustomerLease
              ref="futureLeaseComponent"
              v-if="activeTab === 'leasing' && leaseTab === 'future'"
              @reload="getCustomerInvoices"
              :parent-loading="disableTransfer"
              :active="false"
              :lease-transfer="leaseTransfer"
              :customer="customer"
              :id="id"
              :facility="facility"
            />
          </el-tab-pane>
          <el-tab-pane lazy label="Transfers" name="transfers">
            <LeaseTransferView
              :loading="disableTransfer"
              :lease-transfer="leaseTransfer"
              @reload="getCustomerInvoices"
              ref="leaseTransferView"
              :customer="id"
              :facility="facility"
            >
            </LeaseTransferView>
          </el-tab-pane>
          <el-tab-pane lazy label="History" name="history">
            <CustomerLeaseHistory v-if="activeTab === 'leasing' && leaseTab === 'history'" :facility="facility" :id="id" :customer="{...customer}"/>
          </el-tab-pane>
          <el-tab-pane disabled v-if="!activeLease">
            <el-button
              slot="label"
              :disabled="disableTransfer"
              @click="() => (dialogFormVisible = true)"
              type="primary"
              size="small"
            >
              New Lease
            </el-button>
          </el-tab-pane>
          <el-tab-pane disabled v-if="activeLease && !hasLeaseTransfer">
            <el-button
              slot="label"
              :disabled="disableTransfer"
              @click="openLeaseTransferDialog"
              type="primary"
              size="small"
            >
              Transfer Units
            </el-button>
          </el-tab-pane>
          <el-tab-pane disabled v-if="hasLeaseTransfer">
            <el-button
              slot="label"
              :disabled="disableTransfer || (leaseTransfer && leaseTransfer.transfer && leaseTransfer.transfer.activeStage > 1)"
              type="danger"
              size="small"
              @click="cancelTransfer"
            >
              Cancel Transfer
            </el-button>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="Profile" name="profile" lazy>
        <CustomerProfile v-if="activeTab === 'profile'" :customer-details="{ ...customer }" :id="id" :facility="facility" />
      </el-tab-pane>
      <el-tab-pane label="Employees" name="Employees" lazy>
        <CustomerEmployees
          :id="id"
          :facility="facility"
        />
      </el-tab-pane>
      <el-tab-pane label="Notes" name="notes" lazy>
        <Notes
          v-if="activeTab === 'notes'"
          :customer="customer"
          :id="id"
          :loading="loading"
          :facility="facility"
          @note="(note) => customer.bannerNote = note"
        >
        </Notes>
      </el-tab-pane>
      <el-tab-pane label="Wallet" name="wallet" lazy>
        <el-card :v-loading="loading">
          <div v-if="customer && !customer.customerId">
            <el-button
              type="primary"
              @click="createCustomerInBraintree"
              size="small"
            >
              Create Customer in Braintree
            </el-button>
          </div>
          <CustomerBraintree
            :customer-id="id"
            :facility="facility"
            :customer-data="customer"
            @reload-customer="getCustomer"
            v-else
          />
        </el-card>
      </el-tab-pane>
      <el-tab-pane lazy label="Payments" name="payments">
        <CustomerTransactions
          v-if="activeTab === 'payments'"
          :id="id"
          :facility="facility"
          @reload="getCustomerInvoices"
        />
      </el-tab-pane>
      <el-tab-pane label="Email History" name="emailHistory" lazy>
        <EmailHistory
          v-if="activeTab === 'emailHistory'"
          :facility="selectedFacility"
          :customer="id"
        />
      </el-tab-pane>
      <el-tab-pane lazy label="Units" name="units">
        <CustomerUnits v-if="activeTab === 'units'" :id="id" :facility="facility" />
      </el-tab-pane>
      <el-tab-pane lazy label="Invoicing" name="billing">
        <CustomerBilling
          v-if="activeTab === 'billing'"
          :id="id"
          :facility="facility"
        />
      </el-tab-pane>
      <el-tab-pane lazy label="Documents" name="documents">
        <CustomerDocuments
          :id="id"
          :facility="facility"
          :customer-invoices="[ ...customerInvoices ]"
          :ready="!leaseLoading"
        />
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      id="rental"
      :visible.sync="dialogFormVisible"
      destroy-on-close
      :close-on-click-modal="false"
      width="75%"
    >
      <CustomerRental
        :facility="facility"
        :customer-id="id"
        @close="closeCustomerRental"
      />
    </el-dialog>
    <el-dialog :visible.sync="dialogForLeaseTransfer" width="55%" destroy-on-close>
      <UnitLeaseTransfer
        v-if="activeLease"
        :lease="activeLease"
        :customer="id"
        :facility="facility"
        :tax-exempted="customer.taxExempted"
        @completed="onCompletedTransferCreation"
      />
    </el-dialog>
  </el-card>
</template>
<script>
import axios from 'axios';
import { CUSTOMER_API_BASE, PG_API_BASE, AUTH_API_BASE, LEASING_API, LEASE_TRANSFER_API } from '../env';
import Notes from './Notes';
import Upload from './Uploader';
import CustomerRental from './CustomerRental';
import CustomerOverview from './CustomerOverview';
import CustomerProfile from './CustomerProfile';
import CustomerBraintree from './CustomerBraintree';
import CustomerAccount from './CustomerAccount';
import CustomerUnits from './CustomerUnits';
import CustomerTransactions from './CustomerTransactions';
import CustomerEmployees from './CustomerEmployees';
import CustomerBilling from './CustomerBilling';
import CustomerLeaseView from './CustomerLeaseView';
import CustomerDocuments from './CustomerDocuments';
import CustomerLeaseHistory from './CustomerLeaseHistory';
import CustomerLease from './CustomerLease';
import LeaseTransferView from './LeaseTransferView';
import NoSiteMap from './NoSiteMap';
import CustomerRentalAnvil from './CustomerRentalAnviI';
import UnitLeaseTransfer from './UnitLeaseTransfer';
import EmailHistory from './EmailHistory';
import { getFacility } from '../utils/commonApi';
import { allowAccess } from '../utils/roles';
import RsAnvilApi from '../api/rsAnvilApi';
import { getCustomerById } from '../api/customers';

export default {
  name: 'Customer',
  props: {
    id: { type: String, required: true },
    facility: { type: String, default: null },
    enabledTab: { type: String, default: null },
  },
  components: {
    Notes,
    CustomerRental,
    CustomerDocuments,
    CustomerBraintree,
    CustomerProfile,
    CustomerAccount,
    CustomerUnits,
    CustomerTransactions,
    CustomerEmployees,
    CustomerBilling,
    CustomerLeaseView,
    CustomerLeaseHistory,
    CustomerLease,
    Upload,
    CustomerOverview,
    NoSiteMap,
    CustomerRentalAnvil,
    LeaseTransferView,
    UnitLeaseTransfer,
    EmailHistory,
  },
  data() {
    return {
      customer: {},
      facilityInsurances: [],
      customerInvoices: [],
      facilityData: {},
      transactions: [],
      primaryEmail: { email: '' },
      startLeaseButtonStatus: false,
      contactMultiAccesOption: false,
      reloadDataForOverview: false,
      loading: false,
      leaseLoading: true,
      autopayLoading: false,
      activeTab: 'profile',
      leaseTab: 'lease',
      receiptTab: 'receipt',
      account: {},
      error: '',
      disableTransfer: false,
      kAccount: null,
      emailLoading: false,
      newAccountItemDialog: false,
      dialogForVoidLineItem: false,
      startDialogWarning: false,
      dialogFormVisible: false,
      dialogForLineItems: false,
      dialogForEndDate: false,
      dialogFormInsurance: false,
      dialogFormIdentification: false,
      dialogForLeaseTransfer: false,
      completeLeaseDialog: false,
      selectedInvoice: null,
      voidCreditLineItemLoading: false,
      managerSignerDialog: false,
      transferProgressInterval: null,
      transferProgressTimeout: null,
      cancellationInterval: null,
      creditLineItem: {
        voidReason: '',
        voidValue: 0,
        voidedBy: '',
        voidedAt: new Date(),
        id: '',
      },
      newIdentification: {
        name: '',
        url: '',
      },
      insurance: {
        end: null,
        url: null,
        facility: null,
      },
      insuranceDocument: {
        url: null,
        createdAt: new Date(),
        createdBy: '',
      },
      newLineItem: {
        description: '',
        chargeType: 'DEPOSIT',
        amount: 0,
        accountBalance: 0,
        period: new Date(),
        dueDate: new Date(),
        createdAt: new Date(),
        type: 'CREDIT',
      },
      newLineItemFeeType: '',
      endDate: null,
      newAccount: {
        createdBy: '',
        email: '',
        name: '',
        access: '',
      },
      signers: [],
      managerSignerUrl: '',
      leaseTransfer: null,
    };
  },
  async mounted() {
    try {
      this.loading = true;
      await this.getFacilityData();
      this.loading = false;

      await this.getCustomer();

      if (this.enabledTab) {
        this.activeTab = this.enabledTab;
      }

      const { data } = await axios.get(`${AUTH_API_BASE}/customers`, {
        params: {
          email: this.customer.email,
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.kAccount = data[0];
      await this.getCustomerInvoices();
    } catch (err) {
      this.loading = false;
      if (err.response && err.response.data) {
        this.$message.error({
          title: 'Error',
          message: err.response.data,
        });

        if (err.response.data === 'access_denied') {
          this.$router.push({ name: '404' });
        }
      }
    }
  },
  beforeDestroy() {
    this.clearTransferMonitoring();
    this.clearCancellationMonitoring();
  },
  computed: {
    hasFutureLease() {
      // if (this.leaseTransfer) {
      //   return false;
      // }
      const futureLeasesWithoutLeaseTransfer = this.customerInvoices
        .filter(item => item.future && !item.leaseTransfer);

      if (futureLeasesWithoutLeaseTransfer.length) {
        return true;
      }

      return false;
    },
    invoiceIds() {
      return this.customerInvoices.map(lease => lease._id);
    },
    activeLease() {
      const [activeL] = this.customerInvoices.filter(lease => lease && !lease.future);
      return activeL;
    },
    hasLeaseTransfer() {
      if (this.activeLease) {
        return !!(this.activeLease.leaseTransfer);
      }
      return false;
    },
    canCompleteMoveout() {
      if (!this.hasLeaseTransfer) {
        return true;
      }
      const hasNextStage = this.leaseTransfer
        && this.leaseTransfer.transfer && this.leaseTransfer.transfer.stages
        > this.leaseTransfer.transfer.activeStage;
      if (hasNextStage
          && this.leaseTransfer
          && this.leaseTransfer.stages
          && this.leaseTransfer.stages.length
          && this.leaseTransfer.stages[this.leaseTransfer.transfer.activeStage]) {
        // index is always 0 based, so we don't need to add 1 to get the next stage.
        const nextStageLease = this.leaseTransfer.stages[
          this.leaseTransfer.transfer.activeStage
        ].lease;

        if (nextStageLease && nextStageLease.agreementSigned && nextStageLease.agreementOnS3) {
          return true;
        }
        return false;
      }
      return true;
    },
    customerFutureInvoices() {
      return this.customerInvoices.filter(lease => lease && lease.future);
    },
    selectedFacility() {
      return this.facility || this.$root.state.facility;
    },
    downloadableLeaseAgreement() {
      return this.signers.length === 2 && this.signers[0].status === 'completed' && this.signers[1].status === 'completed';
    },
  },
  watch: {
    async facility() {
      this.loading = true;
      this.customer.insurances = [];
      this.clearTransferMonitoring();
      this.clearCancellationMonitoring();
      await this.getCustomer();
      await this.getCustomerInvoices();
      this.loading = false;
    },
    async id() {
      try {
        this.loading = true;
        this.customer = {};
        this.customer.company = '';
        this.clearTransferMonitoring();
        this.clearCancellationMonitoring();
        await this.getCustomer();
        await this.getCustomerInvoices();
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
  methods: {
    clearTransferMonitoring() {
      if (this.transferProgressInterval) {
        clearInterval(this.transferProgressInterval);
        this.transferProgressInterval = null;
      }
      if (this.transferProgressTimeout) {
        clearTimeout(this.transferProgressTimeout);
        this.transferProgressTimeout = null;
      }
    },
    clearCancellationMonitoring() {
      if (this.cancellationInterval) {
        clearInterval(this.cancellationInterval);
        this.cancellationInterval = null;
      }
    },
    isTransferJustCompleted() {
      if (!this.leaseTransfer || !this.leaseTransfer.transfer || !this.leaseTransfer.transfer.createdAt) {
        return false;
      }
      
      const createdAt = new Date(this.leaseTransfer.transfer.createdAt);
      const now = new Date();
      const timeDiff = now - createdAt;
      const fiveMinutesInMs = 5 * 60 * 1000; // 5 minutes in milliseconds
      
      return timeDiff <= fiveMinutesInMs;
    },
    openLeaseTransferDialog() {
      this.dialogForLeaseTransfer = true;
    },
    onCompletedTransferCreation(transferData) {
      this.disableTransfer = true;
      this.dialogForLeaseTransfer = false;

      this.monitorTransferCreation();
      if (transferData && transferData.message) {
        this.$message.success({
          message: transferData.message,
        });
      }
    },
    async monitorTransferCreation() {
      try {
        const isAlreadyComplete = await this.checkTransferReady();
        
        if (isAlreadyComplete) {
          this.disableTransfer = false;
          this.$message.success({
            message: 'Lease transfer is already complete!',
          });
          return;
        }

        await new Promise(resolve => setTimeout(resolve, 2000));

        await this.monitorTransferProgress();

        this.disableTransfer = false;
        this.$emit('transfer-created');
        this.$message.success({
          message: 'Lease transfer created successfully!',
        });
      } catch (error) {
        this.disableTransfer = false;
        this.$message.error({
          message: 'Error creating lease transfer. Please try again.',
        });
      }
    },

    async monitorTransferProgress() {
      return new Promise((resolve, reject) => {
        this.clearTransferMonitoring();
        this.transferProgressInterval = setInterval(async () => {
          try {
            await this.getCustomerInvoices();
            
            if (!this.hasLeaseTransfer) {
              this.clearTransferMonitoring();
              reject(new Error('Transfer not found'));
              return;
            }

            await this.getLeaseTransfer();

            if (this.leaseTransfer && this.leaseTransfer.transfer && this.leaseTransfer.stages) {
              const expectedStages = this.leaseTransfer.transfer.stages;
              const actualStages = this.leaseTransfer.stages.length;

              if (this.$refs.leaseTransferView) {
                this.$refs.leaseTransferView.updateTransferProgress({
                  current: actualStages,
                  total: expectedStages,
                  message: actualStages >= expectedStages 
                    ? 'Transfer creation complete' 
                    : `Creating transfer stages... (${actualStages}/${expectedStages})`,
                  status: actualStages >= expectedStages ? 'ready' : 'creating',
                  wasJustCompleted: this.isTransferJustCompleted(), // if createdat is less than 5 mins from now it is just completed
                });
              }

              if (actualStages === expectedStages) {
                this.clearTransferMonitoring();
                resolve();
                return;
              }
            }
          } catch (error) {
            console.error('Error checking transfer progress:', error);
            this.clearTransferMonitoring();
            reject(error);
          }
        }, 2000);

        this.transferProgressTimeout = setTimeout(() => {
          this.clearTransferMonitoring();
          reject(new Error('Transfer creation timeout'));
        }, 60000); // 1 minute timeout
      });
    },
    async monitorTransferWithBackoff(maxAttempts = 10, baseDelay = 1000) {
      let attempt = 0;

      while (attempt < maxAttempts) {
        try {
          // Check if transfer is ready
          const isReady = await this.checkTransferReady();

          if (isReady) {
            return true;
          }
          const delay = baseDelay * Math.pow(2, attempt) + Math.random() * 1000;
          await new Promise(resolve => setTimeout(resolve, delay));

          attempt++;
        } catch (error) {
          console.warn(`Transfer check attempt ${attempt + 1} failed:`, error);
          attempt++;
          if (attempt >= maxAttempts) {
            throw new Error('Transfer creation monitoring failed');
          }
        }
      }
      throw new Error('Transfer creation timeout');
    },
    async checkTransferReady() {
      try {
        await this.getCustomerInvoices();

        if (!this.hasLeaseTransfer) {
          this.leaseTransfer = {};
          return false;
        }

        await this.getLeaseTransfer();

        if (this.leaseTransfer && this.leaseTransfer.stages) {
          const allStagesReady = this.leaseTransfer.stages.every(stage => {
            return stage.lease && stage.lease._id && stage.lease.status;
          });
          return allStagesReady;
        }
        return false;
      } catch (error) {
        console.error('Error checking transfer readiness:', error);
        return false;
      }
    },
    async refreshDataOnTabClick(tab) {
      if (tab.name === 'transfers') {
        await this.getLeaseTransfer();
      }
    },
    async getLeaseTransfer() {
      try {
        if (!this.hasLeaseTransfer) {
          this.leaseTransfer = null;
          return;
        }

        const response = await axios.get(`${LEASE_TRANSFER_API}/v1/${this.facility}/${this.activeLease.leaseTransfer}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        this.leaseTransfer = response.data;
        if (this.leaseTransfer.transfer && this.leaseTransfer.stages) {
          const expectedStages = this.leaseTransfer.transfer.stages;
          const actualStages = this.leaseTransfer.stages.length;

          if (actualStages < expectedStages) {
            console.log(`Transfer in progress: ${actualStages}/${expectedStages} stages ready`);
            return false;
          }
          return true;
        }
        return false;
      } catch (error) {
        console.error('Error fetching lease transfer:', error);
        return false;
      }
    },
    async closeCustomerRental() {
      this.dialogFormVisible = false;

      await this.getCustomerInvoices();

      const leaseTabRefMap = {
        lease: this.$refs.activeLeaseComponent,
        future: this.$refs.futureLeaseComponent,
      };
      if (this.activeTab === 'leasing') {
        await leaseTabRefMap[this.leaseTab].getCustomerInvoices();
      }
    },
    async cancelTransfer() {
      if (!this.hasLeaseTransfer) {
        this.$message.error({
          message: 'No lease transfer found.',
        });
        return;
      }
      
      try {
        await axios.delete(`${LEASE_TRANSFER_API}/v1/${this.facility}/${this.activeLease._id}/${this.activeLease.leaseTransfer}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        this.$message.success({
          message: 'Lease transfer cancel initiated.',
        });

        this.disableTransfer = true;

        this.startCancellationMonitoring();

        this.$emit('transfer-cancelled');
      } catch (error) {
        console.error('Error cancelling transfer:', error);
        this.$message.error({
          message: 'Error cancelling lease transfer. Please try again.',
        });
      }
    },

    startCancellationMonitoring() {
      this.clearCancellationMonitoring();
      this.cancellationInterval = setInterval(async () => {
        try {
          await this.getCustomerInvoices();

          if (!this.activeLease || !this.activeLease.leaseTransfer) {
            this.clearCancellationMonitoring();
            this.disableTransfer = false;
            this.leaseTransfer = null;

            this.updateLeaseTransferViewCancellation();

            this.$message.success({
              message: 'Lease transfer has been cancelled successfully!',
            });

            this.$emit('transfer-cancelled');
            return;
          }
        } catch (error) {
          console.error('Error checking cancellation status:', error);
          this.clearCancellationMonitoring();
          this.disableTransfer = false;
        }
      }, 3000);
    },
    updateLeaseTransferViewCancellation() {
      if (this.$refs.leaseTransferView) {
        this.$refs.leaseTransferView.handleTransferCancellation();
      }

      this.refreshAllLeaseData();
    },
    async getCustomer() {
      const customer = await getCustomerById(this.id, this.facility, this.$keycloak.token);
      this.customer = { ...customer };
      this.facilityInsurances = this.customer.insurances
        .filter(insurance => insurance.facility === this.facility)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
    allowAccess(role) {
      return allowAccess(role, this.$keycloak, this.$root.state.facility);
    },
    lineItemBackgroundColor(lineItem) {
      if (lineItem.voided) {
        return 'linear-gradient(35deg, #ff9966, #ff5e62)';
      } else if (lineItem.type === 'DEBIT' && lineItem.transactionType !== 'ADJUSTMENT') {
        return 'linear-gradient(35deg, #4B8673, #0f9b0f)';
      } else if (lineItem.details === 'TAX') {
        return 'linear-gradient(35deg, #AF0171, #790252, #E80F88)';
      } else if (lineItem.details === 'RENT') {
        return 'linear-gradient(35deg, #AF0171, #790252, #E80F88)';
      } else if (lineItem.details === 'FEES') {
        return 'linear-gradient(35deg, #AF0171, #790252, #E80F88)';
      } else if (lineItem.transactionType === 'ADJUSTMENT') {
        return 'linear-gradient(35deg, #F2CD5C, #A61F69, #F2921D)';
      }
      return 'linear-gradient(35deg, #009aca, #0c3da7)';
    },
    async submitVoidLineItem() {
      this.voidCreditLineItemLoading = true;
      const voidItem = this.creditLineItem;
      try {
        await axios.patch(`${LEASING_API}/v1/${this.facility}/${this.activeLease._id}/void/credit/line/item`, {
          ...voidItem,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        await this.getCustomerInvoices();
        this.dialogForVoidLineItem = false;
      } catch (err) {
        this.dialogForVoidLineItem = false;
        await this.getCustomerInvoices();
      }
      this.voidCreditLineItemLoading = false;
    },
    handleCommandForLineItem(command, invoiceLineItem) {
      if (command === 'void') {
        this.dialogForVoidLineItem = true;
        this.creditLineItem.id = invoiceLineItem._id;
        this.creditLineItem.voided = true;
        this.creditLineItem.voidValue = invoiceLineItem.amount;
        this.creditLineItem.voidedBy = this.$keycloak.tokenParsed.email;
      }
    },
    async getFacilityData() {
      if (this.facility) {
        this.facilityData = await getFacility(this.facility, {
          token: this.$keycloak.token,
        });
      }
    },
    async changeTab(tab) {
      if (tab.index === '0') {
        this.reloadDataForOverview = !this.reloadDataForOverview;
      } else if (tab.index === '1') {
        if (this.customer.insurances && this.customer.insurances.length === 0) {
          this.$message.warning({
            title: 'Insurance',
            message: 'Please add insurance for this customer',
          });
        }
      } else if (tab.index === '9') {
        this.loading = true;
        await this.getCustomerInvoices();
        this.loading = false;
      }
    },
    async getCustomerInvoices() {
      this.leaseLoading = true;
      const response = await axios.get(
        `${LEASING_API}/v1/customer/${this.id}/leases`,
        {
          params: {
            facility: this.facility,
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
      this.customerInvoices = response.data;

      this.leaseLoading = false;

      await this.getLeaseTransfer();

      if (this.leaseTab === 'future' && !this.hasFutureLease) {
        this.leaseTab = 'lease';
      }
    },
    async refreshAllLeaseData() {
      await this.getCustomerInvoices();

      if (this.$refs.activeLeaseComponent) {
        await this.$refs.activeLeaseComponent.getCustomerInvoices();
      }
      if (this.$refs.futureLeaseComponent) {
        await this.$refs.futureLeaseComponent.getCustomerInvoices();
      }

      if (this.$refs.leaseTransferView) {
        if (this.activeLease && this.activeLease.leaseTransfer) {
          await this.getLeaseTransfer();
        } else {
          this.leaseTransfer = null;
        }
      }

      this.$emit('lease-data-refreshed');
    },
    async createCustomerInBraintree() {
      this.loading = true;
      const [firstName, lastName] = this.customer.primaryContact && this.customer.primaryContact.name ? this.customer.primaryContact.name.split(' ') : this.customer.fullName.split(' ');

      try {
        await axios.post(
          `${PG_API_BASE}/customer/create`,
          {
            id: this.customer._id,
            firstName,
            lastName,
            email: this.customer.email,
            phone: this.customer.phone,
            company: this.customer.company,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );
        const customer = await axios.put(
          `${CUSTOMER_API_BASE}/customers/v1/${this.id}`,
          {
            customerId: true,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );
        this.customer = customer.data;
      } catch (err) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: err.response.data.message,
        });
      }
      this.loading = false;
    },
    async openManagerSignerDialog() {
      const etchPacket = JSON.parse(this.activeLease.agreement);
      const managerEid = etchPacket.documentGroup.signers[1].eid;
      const documentEid = etchPacket.documentGroup.eid;
      const rsAnvilApi = new RsAnvilApi(this.$keycloak.token);

      const response = await rsAnvilApi.getSignerEmbedUrl(managerEid, documentEid);

      if (response.errors) {
        this.$message.warning({
          title: 'Agreement signature needed',
          message: 'Please check your email and sign the document.',
        });

        this.managerSignerDialog = false;
        return;
      }

      this.managerSignerDialog = true;
      this.managerSignerUrl = response.url;
    },
  },
};
</script>

<style scoped>
.lease-tab-nav > .el-tabs__header > .el-tabs__nav-wrap > div.el-tabs__nav-scroll {
  background: red;
  /* float: right; */
}

.list {
  list-style-type: none;
  text-align: left;
}
.list li {
  padding: 10px;
}

.data {
  text-align: left;
}

.card {
  padding: 10px;
  margin: 10px;
}

.header {
  background-color: crimson;
  color: white;
}

.text {
  font-size: 14px;
  list-style-type: square;
  text-align: left;
}

.item {
  margin-bottom: 18px;
}

.voided {
  background-color: crimson;
}
</style>



// WEBPACK FOOTER //
// src/components/Customer.vue